import { render, staticRenderFns } from "./CallQueues.vue?vue&type=template&id=29f0f360&"
import script from "./CallQueues.vue?vue&type=script&lang=js&"
export * from "./CallQueues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports